<!--
 * @Author: Junjie
 * @Date: 2022-12-07 21:07:55
 * @LastEditTime: 2023-09-11 18:16:24
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/autorunning/AutoRunRecord.vue
-->
<template>
  <div>
    <a-descriptions size="small" title="当前运行情况" :column="2">
      <a-descriptions-item label="运行方式">
        <a-tag>{{ sewegeInfo.autoStatus === 'Y' ? '系统自动运行中...' : '人工值守' }}</a-tag>
      </a-descriptions-item>
      <!-- <a-descriptions-item label="健康状况">
        <a-tag :color="sewegeHealth ? 'green' : 'red'">{{sewegeHealth ? '正常' : '异常'}}</a-tag>
      </a-descriptions-item> -->
      <a-descriptions-item label="值班负责人">{{ dutyPerson }}</a-descriptions-item>
      <!-- <a-descriptions-item label="预案投入">
        <a-button type="link">13</a-button>
      </a-descriptions-item>-->
      <a-descriptions-item label="问题统计">
        <router-link to="/alert/center">{{ unrecoveryAlertCnt }}</router-link
        >个未处理告警， <router-link to="/alert/center">{{ undisposalAlertCnt }}</router-link
        >个未恢复告警， <router-link to="/defect/defRegister">{{ defectCnt }}</router-link
        >个未完结缺陷
      </a-descriptions-item>
    </a-descriptions>
    <a-tabs style="background: #fff;" type="card">
      <a-tab-pane key="1" tab="智能巡检记录">
        <yw-intelligent-patrol-record-list></yw-intelligent-patrol-record-list>
      </a-tab-pane>
      <a-tab-pane key="2" tab="日志">
        <iot-event-log-list></iot-event-log-list>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { httpAction, getAction } from '@/api/manage'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import YwIntelligentPatrolRecordList from '../../maintenance/YwIntelligentPatrolRecordList.vue'
import IotEventLogList from '../event/IotEventLogList.vue'

export default {
  name: 'AutoRunRecord',
  components: {
    YwIntelligentPatrolRecordList,
    IotEventLogList
  },
  data() {
    return {
      description: '智慧值守',
      dutyingRecord: {},
      sewegeInfo: {},
      defectCnt: 0,
      unrecoveryAlertCnt: 0,
      undisposalAlertCnt: 0,
      url: {
        autoConfList: '/device/sewegePlantAutoConfig/list',
        currentDutyRecord: '/duty/dutyRecord/getCurrentDutyRecord',

        alertList: '/alert/iotAlert/list',
        defectList: '/device/defRegister/list'
      }
    }
  },
  created() {
    this.getDutyingPerson()
    this.getSewegeAutoConf()
    this.getDefectList()
    this.getAlertList()
  },
  computed: {
    sewegeHealth() {
      return this.defectCnt + this.unrecoveryAlertCnt <= 0
    },
    dutyPerson() {
      return this.dutyingRecord.dutyPersons && this.dutyingRecord.dutyPersons[0]
        ? this.dutyingRecord.dutyPersons[0].realname + ' ' + this.dutyingRecord.dutyPersons[0]?.phone
        : '无人值守'
    }
  },
  methods: {
    getDefectList() {
      getAction(this.url.defectList, {
        defStatusStr: '0, 1, 2'
      }).then(res => {
        if (res.success) {
          this.defectCnt = res.result.total
        }
      })
    },
    getAlertList() {
      getAction(this.url.alertList, {
        isRecovery: 0
      }).then(res => {
        if (res.success) {
          this.unrecoveryAlertCnt = res.result.total
        }
      })

      getAction(this.url.alertList, {
        disposal: 0
      }).then(res => {
        if (res.success) {
          this.undisposalAlertCnt = res.result.total
        }
      })
    },
    getDutyingPerson() {
      getAction(this.url.currentDutyRecord, {}).then(res => {
        if (res.success) {
          this.dutyingRecord = res.result || {}
        }
      })
    },
    getSewegeAutoConf() {
      getAction(this.url.autoConfList, {}).then(res => {
        if (res.success) {
          const originModel = res.result.records[0]
          if (originModel) {
            this.sewegeInfo = originModel
          }
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
